export default "__VITE_ASSET__CNkwtGB1__"